import BaseComponent from "../../../../baseComponent.js";
import styles from '../textual.scss';

export default class SwitchOption extends BaseComponent {
  constructor(props) {
    super(props);
  }

  handleChange(event) {
    this.props.onChange(this.refs.checkBox.checked);
  }

  componentDidUpdate() {
    this.refs.checkBox.checked = this.props.value;
  }

  componentDidMount() {
    this.refs.checkBox.checked = this.props.value;
  }

  render() {
    return (
      <div className={styles.animation}>
        <div>{this.props.label}</div>
        <div className="switch" style={{lineHeight: "30px"}}>
          <label>
            Off
            <input type="checkbox" ref="checkBox" onChange={this.handleChange}/>
            <span className="lever"/>
            On
          </label>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/widgets/textual/style/switchOption.jsx